import styled from "styled-components";
import { FaTrash } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import { numberWithCommas } from "../helpers/numberFormat";
import MensajeNoHayDatos from "./MensajeNoHayDatos";
import "react-confirm-alert/src/react-confirm-alert.css";

function ListadoPlatos({ platos, eliminarPlato }) {
  const handleEliminar = (data) => {
    confirmAlert({
      title: "¿Deséa eliminar?",
      message:
        "Esta apunto de eliminar un plato, precione si para eliminar, no para cancelar",
      buttons: [
        {
          label: "Si",
          onClick: () => {
            eliminarPlato(data);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <Container>
      {platos && platos.length === 0 ? (
        <MensajeNoHayDatos mensaje="No hay platos creados en este momento" />
      ) : (
        platos.map((plato) => (
          <Card key={plato.id}>
            <CardOpt>
              <button
                type="button"
                title="Eliminar este plato"
                onClick={() => handleEliminar(plato)}
              >
                <FaTrash />
              </button>
            </CardOpt>
            <CardImg>
              <Img src={plato.imagenUrl} alt={plato.nombre} />
            </CardImg>
            <h3>{plato.nombre}</h3>
            <h4>LPS {numberWithCommas(Number(plato.precio).toFixed(2))}</h4>
            <p>{plato.descripcion}</p>
          </Card>
        ))
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 500px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }

  @media (min-width: 1100px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;

const Card = styled.div`
  width: 100%;
  margin-bottom: 20px;
  padding: 1rem;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #f2f2f2;
  -webkit-box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;
  box-shadow: 12px 12px 24px #c9cbd0, -12px -12px 24px #ffffff;

  h3 {
    text-align: center;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  p {
    font-weight: 300;
    text-align: justify;
  }

  h4 {
    font-weight: 500;
    margin-bottom: 10px;
    text-align: right;
  }
`;

const CardImg = styled.div`
  width: 100%;
  height: 200px;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
`;

const CardOpt = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;

  button {
    width: 3rem;
    height: 2rem;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    outline: none;
    transition: all 0.5s ease;
    color: #fff;
    background: #a61f12;
    &:hover {
      background: #d92a1a;
    }
  }
`;

export default ListadoPlatos;
